import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import "./style.scss";
import { useParams } from "react-router-dom";
import {
  Button,
  Container,
  Grid,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import { darken } from "@mui/system";

const RegisterOther = () => {
  const [conferenceId, setConferenceId] = useState("");

  // Form States
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [country, setCountry] = useState("");
  const [role, setRole] = useState("");

  const [countries, setCountries] = useState([]);
  const [conferences, setConferences] = useState([]);

  const [image, setImage] = useState(null);

  const [error, setError] = useState({
    name: "",
    email: "",
    phone: "",
    whatsapp: "",
    country: "",
    role: "",
    conference: "",
  });

  const [loading, setLoading] = useState(false);

  const roles = ["Journalist", "Photographer", "Technician", "Other"];

  // Load Countries
  useEffect(() => {
    const loadCountries = async () => {
      try {
        const res = await axios.get("https://eventscons.com/eventbackendnew/api/countries");
        setCountries(res.data?.data || []);
      } catch (err) {
        console.error(err);
        toast.error("Failed to load countries");
      }
    };
    loadCountries();
  }, []);

  // Load Conferences
  useEffect(() => {
    const loadConferences = async () => {
      try {
        const res = await axios.get(
          "https://eventscons.com/eventbackendnew/api/conferences/all",
          {
            headers: {
              Authorization: `Bearer YOUR_TOKEN_HERE`,
            },
          }
        );

        setConferences(res.data?.data || []);
      } catch (err) {
        console.error("Conference Load Error:", err);
        toast.error("Failed to load conferences");
      }
    };

    loadConferences();
  }, []);

  // Submit to Backend
  const handleSubmit = async () => {
    const fd = new FormData();
    fd.append("name", name);
    fd.append("email", email);
    fd.append("role", role);
    fd.append("phone_number", phone);
    fd.append("whatsapp_number", whatsapp);
    fd.append("nationality", country);
    fd.append("conference_id", conferenceId);
    fd.append("password", "12345678");

    if (image) {
      fd.append("profile_image", image);
    }

    try {
      setLoading(true);

      const response = await axios.post(
        `https://eventscons.com/eventbackendnew/api/conferences/${conferenceId}/others/register`,
        fd,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
          },
        }
      );

      toast.success(
        response.data?.message ||
          "Requires admin permission to complete the registration"
      );
    } catch (error) {
      console.log("API ERROR:", error.response?.data);
      toast.error(error.response?.data?.message || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = (e) => {
    e.preventDefault();

    let validation = {
      name: !name ? "Please enter your name." : "",
      email: !email ? "Please enter email." : "",
      phone: !phone ? "Please enter phone number." : "",
      whatsapp: !whatsapp ? "Please enter WhatsApp number." : "",
      country: !country ? "Please select nationality." : "",
      role: !role ? "Please select your role." : "",
      conference: !conferenceId ? "Please select conference." : "",
    };

    setError(validation);

    const noError = Object.values(validation).every((v) => v === "");
    if (noError) handleSubmit();
  };

  return (
    <Container sx={{ marginTop: "20vh", padding: "20px" }}>
      <Grid container justifyContent="center">
        <Grid item xs={12} md={6}>
          <form onSubmit={handleRegister}>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "space-between" }}
              >
                <Typography variant="h4" sx={{ color: "#c62828" }}>
                  Other Registration
                </Typography>
              </Grid>

              {/* Conference Dropdown */}
              <Grid item xs={12}>
                <FormControl fullWidth error={!!error.conference}>
                  <InputLabel>Conference</InputLabel>
                  <Select
                    label="Conference"
                    value={conferenceId}
                    onChange={(e) => setConferenceId(e.target.value)}
                  >
                    {conferences.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.title}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{error.conference}</FormHelperText>
                </FormControl>
              </Grid>

              {/* Name */}
              <Grid item xs={12}>
                <TextField
                  label="Full Name"
                  fullWidth
                  value={name}
                  error={!!error.name}
                  helperText={error.name}
                  onChange={(e) => setName(e.target.value)}
                />
              </Grid>

              {/* Email */}
              <Grid item xs={12}>
                <TextField
                  label="Email Address"
                  type="email"
                  fullWidth
                  value={email}
                  error={!!error.email}
                  helperText={error.email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Grid>

              {/* Phone */}
              <Grid item xs={12}>
                <TextField
                  label="Phone Number"
                  fullWidth
                  value={phone}
                  error={!!error.phone}
                  helperText={error.phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </Grid>

              {/* WhatsApp */}
              <Grid item xs={12}>
                <TextField
                  label="WhatsApp Number"
                  fullWidth
                  value={whatsapp}
                  error={!!error.whatsapp}
                  helperText={error.whatsapp}
                  onChange={(e) => setWhatsapp(e.target.value)}
                />
              </Grid>

              {/* Nationality */}
              <Grid item xs={12}>
                <FormControl fullWidth error={!!error.country}>
                  <InputLabel>Nationality</InputLabel>
                  <Select
                    label="Nationality"
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                    renderValue={(selected) => {
                      const selectedCountry = countries.find(
                        (c) => c.name === selected
                      );
                      return (
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={selectedCountry?.flag_url}
                            alt=""
                            style={{
                              width: "22px",
                              height: "16px",
                              marginRight: "10px",
                              borderRadius: "3px",
                            }}
                          />
                          {selected}
                        </div>
                      );
                    }}
                  >
                    {countries.map((item) => (
                      <MenuItem key={item.id} value={item.name}>
                        <img
                          src={item.flag_url}
                          alt=""
                          style={{
                            width: "22px",
                            height: "16px",
                            marginRight: "10px",
                            borderRadius: "3px",
                          }}
                        />
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{error.country}</FormHelperText>
                </FormControl>
              </Grid>

              {/* Role */}
              <Grid item xs={12}>
                <FormControl fullWidth error={!!error.role}>
                  <InputLabel>Role</InputLabel>
                  <Select
                    label="Role"
                    value={role}
                    onChange={(e) => setRole(e.target.value)}
                  >
                    {roles.map((item) => (
                      <MenuItem key={item} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormHelperText>{error.role}</FormHelperText>
                </FormControl>
              </Grid>

              {/* IMAGE UPLOAD */}
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  component="label"
                  sx={{
                    backgroundColor: "#9B1321",
                    color: "#fff",
                    "&:hover": { backgroundColor: darken("#dc143c", 0.2) },
                    width: "100%",
                  }}
                >
                  Upload Image
                  <input
                    type="file"
                    hidden
                    accept="image/*"
                    onChange={(e) => setImage(e.target.files[0])}
                  />
                </Button>

                {image && (
                  <Typography sx={{ marginTop: "10px" }}>
                    Selected: {image.name}
                  </Typography>
                )}
              </Grid>

              {/* Submit */}
              <Grid item xs={12} sx={{ textAlign: "right" }}>
                <Button
                  type="submit"
                  sx={{
                    backgroundColor: "#9B1321",
                    color: "#fff",
                    "&:hover": { backgroundColor: darken("#dc143c", 0.2) },
                    width: "50%",
                  }}
                  disabled={loading}
                >
                  {loading ? "Registering..." : "Register"}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </Container>
  );
};

export default RegisterOther;
